import { useMemo } from 'react';
import { TableProps } from '@mui/material';
import { Table } from '../../table/Table';
import { RecipientListColumns } from './RecipientListColumns';
import styles from './ManageRecipients.module.scss';
import { Recipient, RecipientActionsType } from './interface';

interface RecipientListTableProps {
  data: Recipient[];
  actionHandlers: {
    [key in Exclude<RecipientActionsType, RecipientActionsType.ADD>]: (value: Recipient) => void;
  };
  activeRecipient: Recipient;
  tableProps: TableProps;
}
export function RecipientListTable({
  data: recipients,
  actionHandlers,
  activeRecipient,
  tableProps
}: RecipientListTableProps) {
  const rows = useMemo(() => {
    return recipients.map(recipient => ({
      data: recipient,
      active: activeRecipient?.channel_identifier === recipient.channel_identifier,
      tabIndex: 0,
      id: recipient.id,
      actionHandlers
    }));
  }, [recipients, activeRecipient]);

  return (
    <Table
      compactHeader
      columns={RecipientListColumns}
      rows={rows}
      {...tableProps}
      classes={{ rowClass: styles.recipientRow, ...tableProps.classes }}
    />
  );
}
